var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.38784",
      "ably": "static-3.52",
      "apollo-dlb": "static-3.86",
      "client-types": "static-1.487",
      "codemirror-dlb": "static-1.59038",
      "collaboration-sidebar": "static-1.58254",
      "ContentComponents": "static-2.71718",
      "ContentData": "static-1.68837",
      "ContentEditorUI": "static-2.77479",
      "ContentUtils": "static-1.68762",
      "customer-agent-datasources-lib": "static-1.7378",
      "customer-agent-discovery-components-lib": "static-1.3472",
      "customer-agent-forms": "static-1.5067",
      "data-fetching-client": "static-1.9797",
      "editor-components": "static-1.13433",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.39667",
      "foundations-assets": "static-1.5011",
      "foundations-components": "static-1.8208",
      "head-dlb": "static-1.5007",
      "hs-test-utils": "static-1.8157",
      "hub-http": "static-1.6358",
      "hub-http-shared-msw-handlers": "static-1.10302",
      "hubspot-dlb": "static-2.1854",
      "hubspot-prosemirror": "static-1.18622",
      "HubStyleTokens": "static-2.11609",
      "I18n": "static-7.1643",
      "InpageEditorUI": "static-1.85919",
      "jasmine-immutable": "static-1.3159",
      "jasmine-runner": "static-1.6594",
      "layout-dnd-utils": "static-1.11691",
      "personalization-lib": "static-1.7739",
      "quartz": "static-1.7214",
      "react-dlb": "static-1.81",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.71",
      "react-transition-group": "static-2.66",
      "react-utils": "static-2.5445",
      "redux-thunk": "static-2.43",
      "reselect": "static-3.6",
      "settings-ui-lib": "static-1.12659",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4392",
      "ui-components-test-utils": "static-1.5746",
      "ui-images": "static-2.1192",
      "ui-memberships-settings-lib": "static-1.34413",
      "video-components-external": "static-1.11736",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.9293",
      "amplitude-session-replay-browser": "static-1.60",
      "apollo-stack-hubspot": "static-3.84",
      "asset-actions-lib": "static-1.46563",
      "atom": "static-1.5212",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.27333",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.7974",
      "content-label-lib": "static-1.6938",
      "content-management-actions-lib": "static-1.28019",
      "content-management-data-lib": "static-1.5658",
      "content-management-restrictions-lib": "static-1.5459",
      "copilot-plugins": "static-1.11457",
      "copilot-toolkit": "static-1.11484",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.834",
      "cta-picker": "static-1.36753",
      "customer-data-objects": "static-1.7815",
      "customer-data-objects-ui-components": "static-1.13166",
      "customer-data-properties": "static-1.52023",
      "customer-data-property-utils": "static-1.8232",
      "customer-data-reference-ui-components": "static-1.13312",
      "customer-data-ui-utilities": "static-1.9961",
      "data-token-picker": "static-1.16651",
      "data-token-views": "static-1.16632",
      "error-messaging-js": "static-1.5331",
      "feedback-loader": "static-1.29554",
      "file-manager-components": "static-1.24027",
      "FileManagerCore": "static-1.39526",
      "FormsCommonComponents": "static-1.86184",
      "foundations-theming": "static-1.4572",
      "fuzzy": "static-1.8",
      "growth-onboarding-beacon": "static-1.5552",
      "growth-onboarding-confetti": "static-1.3202",
      "growth-onboarding-next-action-components": "static-1.2335",
      "growth-payments-core": "static-1.25777",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.5731",
      "hub-http-contrib": "static-1.3180",
      "hubspot-url-utils": "static-1.4132",
      "HubStyle": "static-2.11916",
      "icons": "static-2.658",
      "immer": "static-1.33",
      "immutable": "static-2.79",
      "InboxConnectUtils": "static-4.15181",
      "integrations-lib": "static-1.16584",
      "interframe": "static-3.4895",
      "laboratory-lib": "static-3.7289",
      "layout-data-lib": "static-1.10016",
      "media-bridge-lib": "static-1.19168",
      "nav-meta": "static-1.29970",
      "object-builder-ui-client": "static-1.49217",
      "onboarding-scopes": "static-1.6597",
      "onboarding-tours": "static-1.16867",
      "onboarding-tours-client": "static-1.5081",
      "outpost": "static-1.4306",
      "page-lib": "static-1.22848",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.23862",
      "payments-post-enroll-local-storage-lib": "static-1.5243",
      "pictos": "static-7.187",
      "PortalIdParser": "static-2.404",
      "products-ui-components": "static-1.40589",
      "property-translator": "static-1.5533",
      "quartz-routing": "static-1.644",
      "quick-fetch": "static-1.4021",
      "raven": "static-3.5925",
      "react": "static-7.187",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.10344",
      "react-dom": "static-7.85",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.16825",
      "react-select-plus": "static-1.106",
      "react-tinymce": "static-1.55605",
      "react-virtualized": "static-2.100",
      "redux": "static-4.16",
      "redux-request-state": "static-1.10784",
      "reference-resolvers": "static-1.8312",
      "reference-resolvers-lite": "static-1.8233",
      "rich-text-lib": "static-1.20071",
      "rpc-client-utils": "static-1.4794",
      "sanitize": "static-1.4614",
      "sanitize-text": "static-1.8283",
      "seamless-immutable": "static-7.6",
      "SharedI18nStrings": "static-1.182",
      "SharedLegalStrings": "static-1.1882",
      "simple-menus-core": "static-1.15359",
      "simple-menus-lib": "static-1.16876",
      "smart-content-lib": "static-1.43465",
      "styled-components": "static-2.89",
      "StyleGuideUI": "static-3.490",
      "superstore": "static-1.4897",
      "theme-previewer-lib": "static-1.53615",
      "tinymce-config": "static-2.54731",
      "tinymce-copilot": "static-1.16799",
      "tinymce-data": "static-1.40816",
      "tinymce-plugins": "static-1.57845",
      "tinymce-themes": "static-1.56701",
      "transmute": "static-2.85",
      "ui-addon-emoji-picker": "static-1.10022",
      "ui-addon-form-validation": "static-1.11128",
      "ui-addon-i18n": "static-1.11286",
      "ui-addon-iframeable": "static-1.9206",
      "ui-addon-opt": "static-4.8498",
      "ui-addon-sales-email": "static-1.5348",
      "ui-addon-upgrades": "static-9.18180",
      "ui-business-units-lib": "static-1.9206",
      "ui-gdpr-components": "static-1.10489",
      "ui-product-approvals": "static-1.28684",
      "ui-shepherd-react": "static-3.10394",
      "ui-suspension-banners-lib": "static-1.6525",
      "UIComponents": "static-3.8555",
      "underscore": "static-1.8",
      "urlinator": "static-1.4672",
      "usage-tracker": "static-1.7490",
      "usage-tracker-core": "static-1.7340",
      "usage-tracker-session-replay": "static-1.5176",
      "user-context": "static-1.5246",
      "video-embed": "static-1.36228",
      "web-interactives-components": "static-1.14001",
      "web-interactives-data": "static-1.14002",
      "wootric-nps": "static-1.7086",
      "xray-recommendation-lib": "static-1.8082",
      "codemirror": "static-5.96",
      "react-codemirror": "static-1.10764",
      "enviro": "static-4.455",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.9637",
      "bend-plugin-trellis-migration": "static-1.3504",
      "moment": "static-3.26",
      "bend-plugin-quartz-routing": "static-1.292",
      "chatspot-widget-iframe": "static-1.21962",
      "collaboration-sidebar-common": "static-1.3051",
      "framework-data-schema-resolvers": "static-1.7031",
      "frontend-preferences-client": "static-1.8064",
      "magpie-lib": "static-1.5643",
      "marketing-platform-lib": "static-1.7003",
      "quartz-config": "static-1.992",
      "quartz-core": "static-1.6433",
      "advanced-menus-core": "static-1.15360",
      "advanced-menus-lib": "static-1.12268",
      "automation-ui-ubb": "static-1.6109",
      "avatar-components": "static-1.2635",
      "cms-field-types": "static-1.4951",
      "content-embed-lib": "static-1.7475",
      "ExportDialog": "static-6.10517",
      "forms-utils-lib": "static-1.12844",
      "foundations-components-legacy": "static-1.1233",
      "integrations-error-boundary-lib": "static-1.13999",
      "messaging-usage-based-billing-components-lib": "static-1.1539",
      "payments-embed-points-lib": "static-1.13319",
      "products-iframe-lib": "static-1.8306",
      "react-dnd-compat": "static-1.4751",
      "ui-addon-draggable-compat": "static-2.4397",
      "ui-brand-identity-lib": "static-1.15782",
      "usage-based-billing-components-lib": "static-1.9511",
      "usage-tracker-container": "static-1.7480",
      "video-data-lib": "static-1.35394",
      "videoconference-integration-components": "static-1.7032",
      "graphql": "static-1.83",
      "backbone": "static-1.6",
      "editor-iframe-lib": "static-1.8598",
      "FireAlarmUi": "static-1.4612",
      "hubspot-apollo-client": "static-1.5014",
      "layout-dnd-components": "static-1.12716",
      "marketing-email-service-types": "static-1.2007",
      "smart-content-core": "static-1.42812",
      "social-composer-lib": "static-1.59644",
      "structured-content-lib": "static-1.25554",
      "timezone-utils": "static-2.5381",
      "ui-addon-video-player": "static-1.8843",
      "ui-asset-management-lib": "static-1.11213",
      "ui-tool-access": "static-1.10288",
      "content-icons-ui": "static-1.2269",
      "conversations-skeleton-state": "static-1.7385",
      "customer-agent-audience-seg-lib": "static-1.1066",
      "customer-agent-short-answers-lib": "static-1.625",
      "prosemirror": "static-1.13",
      "final-form": "static-1.71",
      "foundations-theming-specialty": "static-1.2288",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.67",
      "audio-components": "static-1.6130",
      "FileManagerImages": "static-1.37178",
      "quartz-i18n": "static-1.889",
      "video-components": "static-1.13738",
      "bend-plugin-foundations-components": "static-1.4477",
      "floating-ui": "static-1.58",
      "framer-motion": "static-1.73",
      "hs-story-utils": "static-1.9560",
      "react-create-root-preference": "static-1.41",
      "tanstack-table": "static-1.56",
      "trellis-assets": "static-1.2223",
      "ui-fonts": "static-1.871",
      "HeadJS": "static-2.775",
      "hs-test-utils-bend-plugin": "static-1.3268",
      "msw": "static-1.39",
      "testing-library": "static-1.153",
      "hs-locale-management": "static-1.185",
      "ts-schema": "static-1.4185",
      "content-media-capture": "static-1.4939",
      "knowledge-content-types": "static-1.8559",
      "i18n-data": "static-1.224",
      "moment-timezone": "static-5.84",
      "jquery": "static-3.6",
      "NamespacedHubStyle": "static-2.9157",
      "react-dnd-ipeui-backend": "static-1.2118",
      "ui-coaching-tips": "static-1.28938",
      "jasmine": "static-4.4462",
      "customer-data-filters-ui": "static-1.40281",
      "marketplace-embed": "static-1.22507",
      "ui-addon-react-router-dom": "static-1.9673",
      "flux-actions": "static-1.350",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10500",
      "rxjs": "static-5.10",
      "react-flip-move": "static-1.72",
      "foundations-components-test-utils": "static-1.5691",
      "apollo-link-hub-http": "static-2.4788",
      "content-media-composition-data-lib": "static-1.12743",
      "content-media-compositions": "static-2.16750",
      "idb-keyval": "static-1.45",
      "immerable": "static-1.4288",
      "magpie-types": "static-1.5103",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.21971",
      "chirp-fetch": "static-1.2024",
      "foundations-theming-base": "static-1.3557",
      "sassPrefix": "static-1.158",
      "campaigns-utils-lib": "static-1.3332",
      "attribution-lib": "static-1.42490",
      "crm-message-bus": "static-1.43348",
      "crm-pipelines-api-client-types": "static-1.4241",
      "framework-listing-lib": "static-2.29073",
      "nudge-client-utils": "static-1.2877",
      "nudge-custom-ui-functions": "static-1.1272",
      "reporting-enablement": "static-1.23376",
      "reporting-ui-components": "static-2.65378",
      "ui-addon-teams": "static-1.21728",
      "hubspotter-http": "static-1.4754",
      "ai-rendering-library": "static-1.10671",
      "simple-logging-lib": "static-1.3186",
      "breeze-engine-lib": "static-1.1189",
      "inbound-db-properties-service-client": "static-1.3950",
      "calling-global-api": "static-1.64957",
      "calling-internal-common": "static-1.31449",
      "calling-lifecycle-internal": "static-1.66339",
      "calling-lifecycle-messages": "static-1.58633",
      "commerce-products-lib": "static-1.10071",
      "conditional-properties-service-client": "static-1.3901",
      "crm-links": "static-1.6445",
      "customer-data-properties-shared-msw-handlers": "static-1.9629",
      "external-options-client-types": "static-1.4230",
      "formula-editor": "static-1.14508",
      "google-libphonenumber": "static-1.39",
      "hs-resources": "static-1.315",
      "inbound-db-meta-service-client": "static-1.3691",
      "inbounddb-objects-service-types": "static-1.4321",
      "meetings-icalendar-utils-lib": "static-1.770",
      "multi-currency-client-types": "static-1.3796",
      "pipeline-validation-client-types": "static-1.4070",
      "property-value-citations": "static-1.2637",
      "pulse": "static-1.741",
      "smart-property-lib": "static-1.7965",
      "tiered-pricing": "static-1.1585",
      "topics-actions-lib": "static-1.230",
      "zustand": "static-1.74",
      "react-immutable-render-mixin": "static-1.9",
      "html-to-image": "static-1.55",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.527",
      "ui-universal-auth": "static-1.9144",
      "forms-ai-lib": "static-1.4537",
      "bend-plugin-foundations-theming": "static-1.3055",
      "stylex": "static-1.35",
      "embedded-academy-lib": "static-1.14798",
      "growth-onboarding-feedback-components": "static-1.6716",
      "seat-types-lib": "static-1.311",
      "integrations-tracking-lib": "static-1.5745",
      "native-integrations-shared-strings": "static-1.7917",
      "unified-auth": "static-1.658",
      "purchase-motions-components": "static-1.6122",
      "getting-started-shared-tasks": "static-1.18792",
      "growth-data-modal": "static-1.5658",
      "growth-onboarding-next-action-utils": "static-1.2307",
      "navigation-components": "static-1.18333",
      "onboarding-tours-utils": "static-1.933",
      "ui-shepherd-tracker": "static-1.7775",
      "commerce-tours-lib": "static-1.6358",
      "growth-onboarding-reliability": "static-1.5218",
      "sales-checkout-service-client": "static-1.3723",
      "commerce-permissions": "static-1.912",
      "commerce-subscription-lib": "static-1.37468",
      "commerce-tax-lib": "static-1.674",
      "crm_data": "static-4.92392",
      "customer-data-tracking": "static-1.7024",
      "dispatcher": "static-1.139",
      "framework-data-table": "static-2.12224",
      "price-books-api": "static-1.1300",
      "price-books-components": "static-1.1358",
      "property-description-translator": "static-1.3977",
      "ramp-editor": "static-1.519",
      "quartz-head": "static-1.879",
      "quartz-test": "static-1.889",
      "csstype": "static-1.50",
      "web-vitals": "static-1.7",
      "batch-promise": "static-1.1681",
      "bend-plugin-chirp-manifest": "static-1.204",
      "commerce-tools-ui-lib": "static-1.10735",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "navigation-messaging": "static-1.7660",
      "merchandise-lib": "static-1.266",
      "quartz-auth": "static-1.889",
      "ui-product-approvals-common": "static-1.579",
      "getting-started-shared-tasks-store": "static-1.17910",
      "seo-tools-lib": "static-1.6572",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "bender-build-tools": "static-1.3301",
      "fdsr-migration-layer": "static-1.150",
      "framework-builder-read-service-client": "static-1.4110",
      "framework-data-schema-quick-fetch": "static-1.6936",
      "persist-promise": "static-1.3838",
      "hub-http-janus": "static-1.850",
      "reactive-lib": "static-1.863",
      "general-store": "static-6.20",
      "mobile-manifest-mixins": "static-1.549",
      "module-federation": "static-1.27",
      "quartz-tracking": "static-1.593",
      "trellis-components": "static-1.2242",
      "automation-platform-service-types": "static-1.2632",
      "automation-ui-core": "static-2.22129",
      "automation-ui-types": "static-1.20193",
      "automation-ui-usage-tracking": "static-1.21592",
      "data-studio-ubb": "static-1.3114",
      "messaging-shared-utils-lib": "static-1.988",
      "messaging-user-info-utils-lib": "static-1.1158",
      "commerce-analytics-service-client": "static-1.3711",
      "payments-enrollment-embed-lib": "static-1.23331",
      "highcharts": "static-8.105",
      "platform-infra-nav-components": "static-1.7778",
      "reporting-visualizations": "static-1.60183",
      "subscription-experience-data-types": "static-1.15090",
      "hubspot-apollo-cache": "static-1.473",
      "nested-table": "static-1.377",
      "breeze-engine-core": "static-1.467",
      "social-insights-client-types": "static-1.22409",
      "fix-webm-duration": "static-1.24",
      "notification-sounds": "static-1.4563",
      "customer-data-filters-ui-msw-helpers": "static-1.22716",
      "events-data-lib": "static-1.372",
      "FormUrlGenerator": "static-2.4859",
      "multi-account-reference-resolvers": "static-1.1118",
      "reporting-datasets-permissions-lib": "static-1.14070",
      "trellis-theming": "static-1.1080",
      "connections-embed-lib": "static-1.1256",
      "marketplace-ui-common": "static-1.20219",
      "marketplace-ui-tracking": "static-1.14389",
      "property-management-iframe": "static-1.13621",
      "trellis-ecosystem": "static-1.7388",
      "js-cookie": "static-1.18",
      "markdown-it": "static-1.6",
      "report-customization-components": "static-1.13537",
      "reporting-action-components": "static-1.41647",
      "reporting-data": "static-1.68107",
      "reporting-snowflake": "static-1.56725",
      "restore-request-side-panel-lib": "static-1.1236",
      "customer-data-views-management": "static-1.25728",
      "switchboard-lib": "static-1.363",
      "nudge-custom-function-registry": "static-1.2634",
      "nudge-renderer-utils": "static-1.2953",
      "whisper-core-api": "static-1.6922",
      "data-quality-ui-library": "static-1.13396",
      "reporting-filters": "static-1.661",
      "reporting-insights-lib": "static-1.2142",
      "reporting-plugins": "static-1.10537",
      "reporting-reports": "static-1.67785",
      "breeze-onboarding-components": "static-1.307",
      "highlight.js": "static-1.80",
      "mermaid": "static-1.3",
      "calling-error-reporting": "static-1.31456",
      "shared-worker-versioning": "static-1.11173",
      "calling-usage-tracker": "static-1.6679",
      "voice-sms-access-library": "static-1.1497",
      "products-ui-components-shared-msw-handlers": "static-1.10684",
      "location-customization-utils-lib": "static-1.9647",
      "bark-lib": "static-1.16599",
      "browser-prettier": "static-1.11",
      "crm-properties-common-lib": "static-1.6027",
      "event-emitter": "static-1.1087",
      "bend-plugin-pulse": "static-1.244",
      "fast-json-patch": "static-1.64",
      "data-agent-kit": "static-1.425",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10385",
      "fsm": "static-1.3867",
      "policy-lib": "static-1.6923",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10448",
      "unified-auth-core-lib": "static-1.940",
      "academy-common-lib": "static-1.14258",
      "universal-page-editor-lib": "static-1.3148",
      "adobe-sign-auth-lib": "static-1.75",
      "ads-unified-auth-lib": "static-1.510",
      "google-sheets-integration-lib": "static-1.636",
      "microsoft-drive-integration-lib": "static-1.799",
      "surveymonkey-integration-lib": "static-1.93",
      "slack-ui-library": "static-1.10535",
      "purchase-motions-api": "static-1.6125",
      "signup-constants": "static-1.19202",
      "signup-ui-url-generator": "static-2.8195",
      "onboarding-data-sync-lib": "static-1.2207",
      "user-context-client": "static-1.4715",
      "nest": "static-1.370",
      "commerce-billing-lib": "static-1.19538",
      "commerce-shared-components-lib": "static-1.18882",
      "crm_universal": "static-1.22252",
      "customer-data-email": "static-1.18280",
      "customer-data-associations": "static-1.7469",
      "tanstack-virtual": "static-1.31",
      "line-items-api": "static-1.892",
      "customer-data-rte": "static-1.33346",
      "cv-backend-services": "static-1.1573",
      "growth-onboarding-empty-states": "static-1.6000",
      "qrcode-generator": "static-1.70",
      "quotes-client-types": "static-1.38559",
      "trials-service-types": "static-1.4021",
      "hubspotter-http-shared-msw-handlers": "static-1.10300",
      "base-ui": "static-1.15",
      "react-day-picker": "static-1.4",
      "immutable-less": "static-1.4788",
      "automation-ui-routing": "static-1.21550",
      "sql-reporting-client-types": "static-1.5753",
      "marketplace-ui-apps-core": "static-1.18751",
      "stripe-embedded-components": "static-1.7753",
      "edison-service-client-types": "static-1.525",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.311",
      "integrations-reconnect-lib": "static-1.229",
      "ai-settings-ui-library": "static-1.8109",
      "marketplace-ui-client-types": "static-1.17626",
      "property-management-common": "static-1.5909",
      "storybook-react": "static-1.34",
      "trellis-story-utils": "static-1.4646",
      "dashboard-lib": "static-1.82057",
      "hubspot-prosemirror-plugins": "static-1.18614",
      "share-with-third-party-component-lib": "static-1.8841",
      "reporting-client-types": "static-1.2584",
      "crm-export-dialog": "static-1.6422",
      "crm-index-associations-lib": "static-1.6578",
      "crm-view-components": "static-1.687",
      "campaign-roi-lib": "static-1.9520",
      "ui-addon-calendars": "static-2.5459",
      "calling-orchestration-schema": "static-1.36274",
      "sales-views-client-types": "static-1.4394",
      "crm-record-cards-service-types": "static-1.3690",
      "react-reducer-toolkit": "static-1.15969",
      "academy-service-client": "static-1.3820",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4538",
      "meetings-connect-utils-lib": "static-1.7743",
      "utility-belt": "static-1.2668",
      "sequences-lib": "static-1.8275",
      "draft-content-plugins": "static-1.28612",
      "draft-convert": "static-2.74",
      "draft-extend": "static-3.76",
      "draft-js": "static-5.79",
      "draft-plugins": "static-2.21919",
      "developer-experience-shared-components": "static-1.10663",
      "ui-addon-integrations-directory-panel": "static-2.8148",
      "ui-extensibility-client-types": "static-1.4061",
      "stripe-connect-js": "static-1.71",
      "simple-data-table": "static-1.3160",
      "crm-component-utils": "static-1.39437",
      "redux-actions": "static-3.7",
      "EmailSignatureEditor": "static-1.24672",
      "viral-links-lib": "static-1.7208",
      "crm-index-visualization-core": "static-1.4313",
      "sequences-client-types-lib": "static-1.8132",
      "apps-service-types": "static-1.3937",
      "oauth-service-types": "static-1.4392",
      "card-properties-lib": "static-1.44603",
      "crm-actions": "static-1.6477",
      "crm-cards-sdk": "static-1.43999",
      "sales-email-signature-service-client": "static-1.3986",
      "customer-data-sidebar": "static-2.46388",
      "enrichment-properties-lib": "static-1.17083",
      "universal-record-utils-lib": "static-1.1314",
      "crm-fe-perf": "static-1.23038",
      "card-payment-highlight-lib": "static-1.37559",
      "card-subscription-highlight-lib": "static-1.39891",
      "commerce-contract-lib": "static-1.12707",
      "invoices-highlight-card-lib": "static-1.55167",
      "orders-highlight-card-lib": "static-1.21841",
      "products-highlight-card-lib": "static-1.18354",
      "quotes-highlight-card-lib": "static-1.72469",
      "crm-source-interpretation-lib": "static-1.5468",
      "crm-object-search-query-utilities": "static-1.9885",
      "accounting-integrations-ui-components": "static-1.7289",
      "invoices-ui-lib": "static-1.55183",
      "commerce-products-api": "static-1.2492",
      "invoices-iframe-lib": "static-1.57241",
      "quotes-modal-lib": "static-1.103147",
      "quotes-ui-lib": "static-1.81190",
      "totals-ui-components": "static-1.23965",
      "SalesContentIndexUI": "static-3.9438",
      "commerce-totals-service-types": "static-1.3921",
      "sales-templates-service-types-lib": "static-1.4274"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.38784",
      "ably": "/ably/static-3.52",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "client-types": "/client-types/static-1.487",
      "codemirror-dlb": "/codemirror-dlb/static-1.59038",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58254",
      "ContentComponents": "/ContentComponents/static-2.71718",
      "ContentData": "/ContentData/static-1.68837",
      "ContentEditorUI": "/ContentEditorUI/static-2.77479",
      "ContentUtils": "/ContentUtils/static-1.68762",
      "customer-agent-datasources-lib": "/customer-agent-datasources-lib/static-1.7378",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3472",
      "customer-agent-forms": "/customer-agent-forms/static-1.5067",
      "data-fetching-client": "/data-fetching-client/static-1.9797",
      "editor-components": "/editor-components/static-1.13433",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.39667",
      "foundations-assets": "/foundations-assets/static-1.5011",
      "foundations-components": "/foundations-components/static-1.8208",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-test-utils": "/hs-test-utils/static-1.8157",
      "hub-http": "/hub-http/static-1.6358",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10302",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18622",
      "HubStyleTokens": "/HubStyleTokens/static-2.11609",
      "I18n": "/I18n/static-7.1643",
      "InpageEditorUI": "/InpageEditorUI/static-1.85919",
      "jasmine-immutable": "/jasmine-immutable/static-1.3159",
      "jasmine-runner": "/jasmine-runner/static-1.6594",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11691",
      "personalization-lib": "/personalization-lib/static-1.7739",
      "quartz": "/quartz/static-1.7214",
      "react-dlb": "/react-dlb/static-1.81",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.71",
      "react-transition-group": "/react-transition-group/static-2.66",
      "react-utils": "/react-utils/static-2.5445",
      "redux-thunk": "/redux-thunk/static-2.43",
      "reselect": "/reselect/static-3.6",
      "settings-ui-lib": "/settings-ui-lib/static-1.12659",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4392",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5746",
      "ui-images": "/ui-images/static-2.1192",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34413",
      "video-components-external": "/video-components-external/static-1.11736",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9293",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
      "asset-actions-lib": "/asset-actions-lib/static-1.46563",
      "atom": "/atom/static-1.5212",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.27333",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.7974",
      "content-label-lib": "/content-label-lib/static-1.6938",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.28019",
      "content-management-data-lib": "/content-management-data-lib/static-1.5658",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.5459",
      "copilot-plugins": "/copilot-plugins/static-1.11457",
      "copilot-toolkit": "/copilot-toolkit/static-1.11484",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.834",
      "cta-picker": "/cta-picker/static-1.36753",
      "customer-data-objects": "/customer-data-objects/static-1.7815",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13166",
      "customer-data-properties": "/customer-data-properties/static-1.52023",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8232",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13312",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9961",
      "data-token-picker": "/data-token-picker/static-1.16651",
      "data-token-views": "/data-token-views/static-1.16632",
      "error-messaging-js": "/error-messaging-js/static-1.5331",
      "feedback-loader": "/feedback-loader/static-1.29554",
      "file-manager-components": "/file-manager-components/static-1.24027",
      "FileManagerCore": "/FileManagerCore/static-1.39526",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.86184",
      "foundations-theming": "/foundations-theming/static-1.4572",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.5552",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3202",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2335",
      "growth-payments-core": "/growth-payments-core/static-1.25777",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.5731",
      "hub-http-contrib": "/hub-http-contrib/static-1.3180",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "HubStyle": "/HubStyle/static-2.11916",
      "icons": "/icons/static-2.658",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.79",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15181",
      "integrations-lib": "/integrations-lib/static-1.16584",
      "interframe": "/interframe/static-3.4895",
      "laboratory-lib": "/laboratory-lib/static-3.7289",
      "layout-data-lib": "/layout-data-lib/static-1.10016",
      "media-bridge-lib": "/media-bridge-lib/static-1.19168",
      "nav-meta": "/nav-meta/static-1.29970",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49217",
      "onboarding-scopes": "/onboarding-scopes/static-1.6597",
      "onboarding-tours": "/onboarding-tours/static-1.16867",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5081",
      "outpost": "/outpost/static-1.4306",
      "page-lib": "/page-lib/static-1.22848",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.23862",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5243",
      "pictos": "/pictos/static-7.187",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "products-ui-components": "/products-ui-components/static-1.40589",
      "property-translator": "/property-translator/static-1.5533",
      "quartz-routing": "/quartz-routing/static-1.644",
      "quick-fetch": "/quick-fetch/static-1.4021",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.187",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.10344",
      "react-dom": "/react-dom/static-7.85",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.16825",
      "react-select-plus": "/react-select-plus/static-1.106",
      "react-tinymce": "/react-tinymce/static-1.55605",
      "react-virtualized": "/react-virtualized/static-2.100",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.10784",
      "reference-resolvers": "/reference-resolvers/static-1.8312",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8233",
      "rich-text-lib": "/rich-text-lib/static-1.20071",
      "rpc-client-utils": "/rpc-client-utils/static-1.4794",
      "sanitize": "/sanitize/static-1.4614",
      "sanitize-text": "/sanitize-text/static-1.8283",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1882",
      "simple-menus-core": "/simple-menus-core/static-1.15359",
      "simple-menus-lib": "/simple-menus-lib/static-1.16876",
      "smart-content-lib": "/smart-content-lib/static-1.43465",
      "styled-components": "/styled-components/static-2.89",
      "StyleGuideUI": "/StyleGuideUI/static-3.490",
      "superstore": "/superstore/static-1.4897",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.53615",
      "tinymce-config": "/tinymce-config/static-2.54731",
      "tinymce-copilot": "/tinymce-copilot/static-1.16799",
      "tinymce-data": "/tinymce-data/static-1.40816",
      "tinymce-plugins": "/tinymce-plugins/static-1.57845",
      "tinymce-themes": "/tinymce-themes/static-1.56701",
      "transmute": "/transmute/static-2.85",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10022",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11128",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11286",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9206",
      "ui-addon-opt": "/ui-addon-opt/static-4.8498",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5348",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18180",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9206",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10489",
      "ui-product-approvals": "/ui-product-approvals/static-1.28684",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10394",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.6525",
      "UIComponents": "/UIComponents/static-3.8555",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.4672",
      "usage-tracker": "/usage-tracker/static-1.7490",
      "usage-tracker-core": "/usage-tracker-core/static-1.7340",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5176",
      "user-context": "/user-context/static-1.5246",
      "video-embed": "/video-embed/static-1.36228",
      "web-interactives-components": "/web-interactives-components/static-1.14001",
      "web-interactives-data": "/web-interactives-data/static-1.14002",
      "wootric-nps": "/wootric-nps/static-1.7086",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8082",
      "codemirror": "/codemirror/static-5.96",
      "react-codemirror": "/react-codemirror/static-1.10764",
      "enviro": "/enviro/static-4.455",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.9637",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3504",
      "moment": "/moment/static-3.26",
      "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.292",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21962",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3051",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7031",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8064",
      "magpie-lib": "/magpie-lib/static-1.5643",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7003",
      "quartz-config": "/quartz-config/static-1.992",
      "quartz-core": "/quartz-core/static-1.6433",
      "advanced-menus-core": "/advanced-menus-core/static-1.15360",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12268",
      "automation-ui-ubb": "/automation-ui-ubb/static-1.6109",
      "avatar-components": "/avatar-components/static-1.2635",
      "cms-field-types": "/cms-field-types/static-1.4951",
      "content-embed-lib": "/content-embed-lib/static-1.7475",
      "ExportDialog": "/ExportDialog/static-6.10517",
      "forms-utils-lib": "/forms-utils-lib/static-1.12844",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1233",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13999",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1539",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13319",
      "products-iframe-lib": "/products-iframe-lib/static-1.8306",
      "react-dnd-compat": "/react-dnd-compat/static-1.4751",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4397",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15782",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9511",
      "usage-tracker-container": "/usage-tracker-container/static-1.7480",
      "video-data-lib": "/video-data-lib/static-1.35394",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.7032",
      "graphql": "/graphql/static-1.83",
      "backbone": "/backbone/static-1.6",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.8598",
      "FireAlarmUi": "/FireAlarmUi/static-1.4612",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5014",
      "layout-dnd-components": "/layout-dnd-components/static-1.12716",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2007",
      "smart-content-core": "/smart-content-core/static-1.42812",
      "social-composer-lib": "/social-composer-lib/static-1.59644",
      "structured-content-lib": "/structured-content-lib/static-1.25554",
      "timezone-utils": "/timezone-utils/static-2.5381",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8843",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11213",
      "ui-tool-access": "/ui-tool-access/static-1.10288",
      "content-icons-ui": "/content-icons-ui/static-1.2269",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7385",
      "customer-agent-audience-seg-lib": "/customer-agent-audience-seg-lib/static-1.1066",
      "customer-agent-short-answers-lib": "/customer-agent-short-answers-lib/static-1.625",
      "prosemirror": "/prosemirror/static-1.13",
      "final-form": "/final-form/static-1.71",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2288",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.67",
      "audio-components": "/audio-components/static-1.6130",
      "FileManagerImages": "/FileManagerImages/static-1.37178",
      "quartz-i18n": "/quartz-i18n/static-1.889",
      "video-components": "/video-components/static-1.13738",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4477",
      "floating-ui": "/floating-ui/static-1.58",
      "framer-motion": "/framer-motion/static-1.73",
      "hs-story-utils": "/hs-story-utils/static-1.9560",
      "react-create-root-preference": "/react-create-root-preference/static-1.41",
      "tanstack-table": "/tanstack-table/static-1.56",
      "trellis-assets": "/trellis-assets/static-1.2223",
      "ui-fonts": "/ui-fonts/static-1.871",
      "HeadJS": "/HeadJS/static-2.775",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3268",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.153",
      "hs-locale-management": "/hs-locale-management/static-1.185",
      "ts-schema": "/ts-schema/static-1.4185",
      "content-media-capture": "/content-media-capture/static-1.4939",
      "knowledge-content-types": "/knowledge-content-types/static-1.8559",
      "i18n-data": "/i18n-data/static-1.224",
      "moment-timezone": "/moment-timezone/static-5.84",
      "jquery": "/jquery/static-3.6",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9157",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.2118",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28938",
      "jasmine": "/jasmine/static-4.4462",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40281",
      "marketplace-embed": "/marketplace-embed/static-1.22507",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9673",
      "flux-actions": "/flux-actions/static-1.350",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10500",
      "rxjs": "/rxjs/static-5.10",
      "react-flip-move": "/react-flip-move/static-1.72",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5691",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4788",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12743",
      "content-media-compositions": "/content-media-compositions/static-2.16750",
      "idb-keyval": "/idb-keyval/static-1.45",
      "immerable": "/immerable/static-1.4288",
      "magpie-types": "/magpie-types/static-1.5103",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.21971",
      "chirp-fetch": "/chirp-fetch/static-1.2024",
      "foundations-theming-base": "/foundations-theming-base/static-1.3557",
      "sassPrefix": "/sassPrefix/static-1.158",
      "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3332",
      "attribution-lib": "/attribution-lib/static-1.42490",
      "crm-message-bus": "/crm-message-bus/static-1.43348",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4241",
      "framework-listing-lib": "/framework-listing-lib/static-2.29073",
      "nudge-client-utils": "/nudge-client-utils/static-1.2877",
      "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1272",
      "reporting-enablement": "/reporting-enablement/static-1.23376",
      "reporting-ui-components": "/reporting-ui-components/static-2.65378",
      "ui-addon-teams": "/ui-addon-teams/static-1.21728",
      "hubspotter-http": "/hubspotter-http/static-1.4754",
      "ai-rendering-library": "/ai-rendering-library/static-1.10671",
      "simple-logging-lib": "/simple-logging-lib/static-1.3186",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1189",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3950",
      "calling-global-api": "/calling-global-api/static-1.64957",
      "calling-internal-common": "/calling-internal-common/static-1.31449",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66339",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58633",
      "commerce-products-lib": "/commerce-products-lib/static-1.10071",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3901",
      "crm-links": "/crm-links/static-1.6445",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9629",
      "external-options-client-types": "/external-options-client-types/static-1.4230",
      "formula-editor": "/formula-editor/static-1.14508",
      "google-libphonenumber": "/google-libphonenumber/static-1.39",
      "hs-resources": "/hs-resources/static-1.315",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3691",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4321",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.770",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3796",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4070",
      "property-value-citations": "/property-value-citations/static-1.2637",
      "pulse": "/pulse/static-1.741",
      "smart-property-lib": "/smart-property-lib/static-1.7965",
      "tiered-pricing": "/tiered-pricing/static-1.1585",
      "topics-actions-lib": "/topics-actions-lib/static-1.230",
      "zustand": "/zustand/static-1.74",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "html-to-image": "/html-to-image/static-1.55",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.527",
      "ui-universal-auth": "/ui-universal-auth/static-1.9144",
      "forms-ai-lib": "/forms-ai-lib/static-1.4537",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3055",
      "stylex": "/stylex/static-1.35",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14798",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6716",
      "seat-types-lib": "/seat-types-lib/static-1.311",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5745",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7917",
      "unified-auth": "/unified-auth/static-1.658",
      "purchase-motions-components": "/purchase-motions-components/static-1.6122",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18792",
      "growth-data-modal": "/growth-data-modal/static-1.5658",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2307",
      "navigation-components": "/navigation-components/static-1.18333",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.933",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7775",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6358",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5218",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
      "commerce-permissions": "/commerce-permissions/static-1.912",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37468",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.674",
      "crm_data": "/crm_data/static-4.92392",
      "customer-data-tracking": "/customer-data-tracking/static-1.7024",
      "dispatcher": "/dispatcher/static-1.139",
      "framework-data-table": "/framework-data-table/static-2.12224",
      "price-books-api": "/price-books-api/static-1.1300",
      "price-books-components": "/price-books-components/static-1.1358",
      "property-description-translator": "/property-description-translator/static-1.3977",
      "ramp-editor": "/ramp-editor/static-1.519",
      "quartz-head": "/quartz-head/static-1.879",
      "quartz-test": "/quartz-test/static-1.889",
      "csstype": "/csstype/static-1.50",
      "web-vitals": "/web-vitals/static-1.7",
      "batch-promise": "/batch-promise/static-1.1681",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.204",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10735",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "navigation-messaging": "/navigation-messaging/static-1.7660",
      "merchandise-lib": "/merchandise-lib/static-1.266",
      "quartz-auth": "/quartz-auth/static-1.889",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.579",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17910",
      "seo-tools-lib": "/seo-tools-lib/static-1.6572",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "bender-build-tools": "/bender-build-tools/static-1.3301",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.150",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4110",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6936",
      "persist-promise": "/persist-promise/static-1.3838",
      "hub-http-janus": "/hub-http-janus/static-1.850",
      "reactive-lib": "/reactive-lib/static-1.863",
      "general-store": "/general-store/static-6.20",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
      "module-federation": "/module-federation/static-1.27",
      "quartz-tracking": "/quartz-tracking/static-1.593",
      "trellis-components": "/trellis-components/static-1.2242",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
      "automation-ui-core": "/automation-ui-core/static-2.22129",
      "automation-ui-types": "/automation-ui-types/static-1.20193",
      "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21592",
      "data-studio-ubb": "/data-studio-ubb/static-1.3114",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.988",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1158",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3711",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23331",
      "highcharts": "/highcharts/static-8.105",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7778",
      "reporting-visualizations": "/reporting-visualizations/static-1.60183",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15090",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.473",
      "nested-table": "/nested-table/static-1.377",
      "breeze-engine-core": "/breeze-engine-core/static-1.467",
      "social-insights-client-types": "/social-insights-client-types/static-1.22409",
      "fix-webm-duration": "/fix-webm-duration/static-1.24",
      "notification-sounds": "/notification-sounds/static-1.4563",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22716",
      "events-data-lib": "/events-data-lib/static-1.372",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4859",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1118",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14070",
      "trellis-theming": "/trellis-theming/static-1.1080",
      "connections-embed-lib": "/connections-embed-lib/static-1.1256",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20219",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14389",
      "property-management-iframe": "/property-management-iframe/static-1.13621",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7388",
      "js-cookie": "/js-cookie/static-1.18",
      "markdown-it": "/markdown-it/static-1.6",
      "report-customization-components": "/report-customization-components/static-1.13537",
      "reporting-action-components": "/reporting-action-components/static-1.41647",
      "reporting-data": "/reporting-data/static-1.68107",
      "reporting-snowflake": "/reporting-snowflake/static-1.56725",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1236",
      "customer-data-views-management": "/customer-data-views-management/static-1.25728",
      "switchboard-lib": "/switchboard-lib/static-1.363",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2634",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2953",
      "whisper-core-api": "/whisper-core-api/static-1.6922",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.13396",
      "reporting-filters": "/reporting-filters/static-1.661",
      "reporting-insights-lib": "/reporting-insights-lib/static-1.2142",
      "reporting-plugins": "/reporting-plugins/static-1.10537",
      "reporting-reports": "/reporting-reports/static-1.67785",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.307",
      "highlight.js": "/highlight.js/static-1.80",
      "mermaid": "/mermaid/static-1.3",
      "calling-error-reporting": "/calling-error-reporting/static-1.31456",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11173",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6679",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1497",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10684",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9647",
      "bark-lib": "/bark-lib/static-1.16599",
      "browser-prettier": "/browser-prettier/static-1.11",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6027",
      "event-emitter": "/event-emitter/static-1.1087",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.244",
      "fast-json-patch": "/fast-json-patch/static-1.64",
      "data-agent-kit": "/data-agent-kit/static-1.425",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10385",
      "fsm": "/fsm/static-1.3867",
      "policy-lib": "/policy-lib/static-1.6923",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10448",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.940",
      "academy-common-lib": "/academy-common-lib/static-1.14258",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3148",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.75",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.510",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.636",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.799",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.93",
      "slack-ui-library": "/slack-ui-library/static-1.10535",
      "purchase-motions-api": "/purchase-motions-api/static-1.6125",
      "signup-constants": "/signup-constants/static-1.19202",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8195",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2207",
      "user-context-client": "/user-context-client/static-1.4715",
      "nest": "/nest/static-1.370",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19538",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18882",
      "crm_universal": "/crm_universal/static-1.22252",
      "customer-data-email": "/customer-data-email/static-1.18280",
      "customer-data-associations": "/customer-data-associations/static-1.7469",
      "tanstack-virtual": "/tanstack-virtual/static-1.31",
      "line-items-api": "/line-items-api/static-1.892",
      "customer-data-rte": "/customer-data-rte/static-1.33346",
      "cv-backend-services": "/cv-backend-services/static-1.1573",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6000",
      "qrcode-generator": "/qrcode-generator/static-1.70",
      "quotes-client-types": "/quotes-client-types/static-1.38559",
      "trials-service-types": "/trials-service-types/static-1.4021",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10300",
      "base-ui": "/base-ui/static-1.15",
      "react-day-picker": "/react-day-picker/static-1.4",
      "immutable-less": "/immutable-less/static-1.4788",
      "automation-ui-routing": "/automation-ui-routing/static-1.21550",
      "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5753",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18751",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7753",
      "edison-service-client-types": "/edison-service-client-types/static-1.525",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.311",
      "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.229",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8109",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17626",
      "property-management-common": "/property-management-common/static-1.5909",
      "storybook-react": "/storybook-react/static-1.34",
      "trellis-story-utils": "/trellis-story-utils/static-1.4646",
      "dashboard-lib": "/dashboard-lib/static-1.82057",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18614",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8841",
      "reporting-client-types": "/reporting-client-types/static-1.2584",
      "crm-export-dialog": "/crm-export-dialog/static-1.6422",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6578",
      "crm-view-components": "/crm-view-components/static-1.687",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9520",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5459",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36274",
      "sales-views-client-types": "/sales-views-client-types/static-1.4394",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3690",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.15969",
      "academy-service-client": "/academy-service-client/static-1.3820",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4538",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7743",
      "utility-belt": "/utility-belt/static-1.2668",
      "sequences-lib": "/sequences-lib/static-1.8275",
      "draft-content-plugins": "/draft-content-plugins/static-1.28612",
      "draft-convert": "/draft-convert/static-2.74",
      "draft-extend": "/draft-extend/static-3.76",
      "draft-js": "/draft-js/static-5.79",
      "draft-plugins": "/draft-plugins/static-2.21919",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10663",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8148",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4061",
      "stripe-connect-js": "/stripe-connect-js/static-1.71",
      "simple-data-table": "/simple-data-table/static-1.3160",
      "crm-component-utils": "/crm-component-utils/static-1.39437",
      "redux-actions": "/redux-actions/static-3.7",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24672",
      "viral-links-lib": "/viral-links-lib/static-1.7208",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4313",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8132",
      "apps-service-types": "/apps-service-types/static-1.3937",
      "oauth-service-types": "/oauth-service-types/static-1.4392",
      "card-properties-lib": "/card-properties-lib/static-1.44603",
      "crm-actions": "/crm-actions/static-1.6477",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43999",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3986",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46388",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17083",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1314",
      "crm-fe-perf": "/crm-fe-perf/static-1.23038",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37559",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39891",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12707",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55167",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21841",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18354",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72469",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5468",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9885",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7289",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55183",
      "commerce-products-api": "/commerce-products-api/static-1.2492",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57241",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103147",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81190",
      "totals-ui-components": "/totals-ui-components/static-1.23965",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9438",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3921",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4274"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.38784",
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};